import background from '@/assets/background.png';
import ViatelLogo from '@/components/common/ViatelLogo';
import { Stack, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

const Home = () => {
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isAuthenticated) return;

    sessionStorage.setItem('authRedirectUrl', `/builder`);
    auth.signinRedirect();
  }, [auth.isAuthenticated]);

  return (
    <Stack
      height='100%'
      alignItems='center'
      justifyContent='center'
      sx={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${background})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }}
    >
      <Box
        height={200}
        width={400}
        display='flex'
        flexDirection='column'
        justifyContent='space-around'
        bgcolor='#292a2f'
        border='1px solid white'
        borderRadius={5}
        px={4}
      >
        <ViatelLogo white />
        <Box display='flex' alignItems='center' flexDirection='column' pb={3}>
          <Typography fontSize={28} color='white' mb={2}>
            Block Engine
          </Typography>
          <Button
            variant='contained'
            autoFocus
            disableRipple
            onClick={() => auth.signinRedirect()}
            onKeyDown={(e) => e.key === 'Enter' && auth.signinRedirect()}
            sx={{ px: 15, py: '12px', borderRadius: 2, fontSize: 15 }}
          >
            Log In
          </Button>
        </Box>
      </Box>
    </Stack>
  );
};

export default Home;
